import React from 'react';
import { diagnosticFlow } from '../data/content';
export function SystemOverview() {
  return <section className="bg-navy px-3 py-4 text-white sm:px-6" data-id="element-150" data-mp="18vski2oh9av8">
      <div className="mx-auto max-w-2xl text-center" data-id="element-151" data-mp="18tg43tydb8ka">
        <h2 className="font-display text-[1.35rem] font-extrabold uppercase leading-none sm:text-[1.85rem]" data-id="element-152" data-mp="1mlm8kis5rr3w">
          EVERYTHING YOU NEED. <span className="text-signal" data-id="element-153" data-mp="1hocj534rrfg2">ONE COMPLETE FIBER OPTIC DIAGNOSTIC SYSTEM.</span>
        </h2>
        <p className="mt-1 text-[0.78rem] font-semibold text-white/80 sm:text-[0.92rem]" data-id="element-154" data-mp="u02u7sc9ebkp">
          6 Advanced Professional Diagnostic Resources In One Organized System
        </p>
        <p className="mt-2 font-display text-[1.05rem] font-extrabold uppercase text-gold sm:text-[1.3rem]" data-id="element-155" data-mp="13xqzvdbel3hn">
          🔬 FIBER OPTIC DIAGNOSTIC PRO™
        </p>
        <p className="mt-1 text-[0.78rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-156" data-mp="2fatfa51rnn08">
          FIBER OPTIC DIAGNOSTIC PRO™ brings advanced fiber fault analysis, professional OTDR interpretation,
          optical power diagnostics, connector and splice failure investigation, FTTH/PON troubleshooting, and
          real-world diagnostic workflows together in one organized professional system.
        </p>
        <p className="mt-2 inline-block rounded-md border border-signal/60 bg-navy-soft px-2.5 py-1 font-display text-[0.56rem] font-extrabold uppercase text-white sm:text-[0.8rem]" data-id="element-157" data-mp="2d5lhdegolwa6">
          {diagnosticFlow.map((step, i) => <React.Fragment key={step} data-id="element-158" data-mp="1khpo6jqbmmi5" data-mpi={i}>
              {i > 0 ? <span className="text-signal" data-id="element-159" data-mp="1peg14y6tx1zc"> → </span> : null}
              {step}
            </React.Fragment>)}
        </p>
      </div>
    </section>;
}